import React from "react";
import VIEWS from "components/MenuBottom/views.js";
import "components/MenuBottom/MenuBottom.module.scss";
import styles from "./Principal.module.scss";
import { favoritos, imprimir, faq, sobre } from "assets/images";
import "../../../index.css";

const Principal = props => {
    const { setView } = props;

    return (
        <div className={styles.menuBottom}>
            <div
                onClick={() => setView(VIEWS.FAVORITOS)}
                className={styles.menuItem}
            >
                <div className={styles.iconBorder}>
                    <img
                        src={favoritos}
                        alt="Busca"
                        className={styles.iconImage}
                    />
                </div>
                <div className={styles.name}>Favoritos</div>
            </div>
            {props.estabelecimentos && props.estabelecimentos.length !== 0 ? (
                <div className={styles.menuItem}>
                    <div className={styles.iconBorder}>
                        <img
                            src={imprimir}
                            alt="Imprimir"
                            className={styles.iconImage}
                        />
                    </div>
                    <div className={styles.name} onClick={() => window.print()}>
                        Imprimir
                    </div>
                </div>
            ) : null}
            <div onClick={() => setView(VIEWS.FAQ)} className={styles.menuItem}>
                <div className={styles.iconBorder}>
                    <img src={faq} alt="Faq" className={styles.iconImage} />
                </div>
                <div className={styles.name}>FAQ</div>
            </div>
            <div
                onClick={() => setView(VIEWS.SOBRE)}
                className={styles.menuItem}
            >
                <div className={styles.iconBorder}>
                    <img src={sobre} alt="Sobre" className={styles.iconImage} />
                </div>
                <div className={styles.name}>Sobre</div>
            </div>
        </div>
    );
};

export default Principal;
